import { combineReducers } from 'redux';
import cloudAnalyzer from './cloudAnalyzer.reducer';

var cloudAnalyzerReducers = combineReducers({
	cloudAnalyzer: cloudAnalyzer
});

export default cloudAnalyzerReducers;
